import React from "react";

import {
  ActionsContainer,
  ActionsColumn,
  ActionsButton,
  ActionsColumnsContainer,
} from "./styles";

import Emoji from "../../../cards-v2/components/actions/icons/Emoji";
import Link from "../../../cards-v2/components/actions/icons/Link";

import { useCountdownStore } from "../../../../stores/use-countdown-store";
import { COUNTDOWN_PROPS } from "../../../../optics/components/drawers/settings/features/countdown/defaults";

const Actions = () => {
  const { setAction, data } = useCountdownStore((state) => ({
    data: state.data,
    setAction: state.setAction,
  }));

  if (
    !data[COUNTDOWN_PROPS.TIMER_LAYOUT].find(({ value }) => value === "icon")
  ) {
    return null;
  }

  return (
    <ActionsContainer onClick={(event) => event.stopPropagation()}>
      <ActionsColumnsContainer>
        <ActionsColumn>
          <ActionsButton
            onClick={() => {
              setAction({ data, drawer: "icon" });
            }}
          >
            <Emoji />
          </ActionsButton>

          <ActionsButton
            onClick={() => {
              setAction({ data, drawer: "link" });
            }}
          >
            <Link />
          </ActionsButton>
        </ActionsColumn>
      </ActionsColumnsContainer>
    </ActionsContainer>
  );
};

export default Actions;
